import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { CmsConfig, ConfigModule, DeferLoadingStrategy, I18nModule, UrlModule } from '@spartacus/core';
import { MyaccountEditPreferencesComponent } from './myaccount-edit-preferences.component';

@NgModule({
  declarations: [MyaccountEditPreferencesComponent],
  imports: [
    CommonModule,
    I18nModule,
    MatCardModule,
    MatCheckboxModule,
    MatIconModule,
    RouterModule,
    UrlModule,
    ConfigModule.withConfig({
      cmsComponents: {
        AccountEditPreferencesPreferencesFlexComponent: {
          component: MyaccountEditPreferencesComponent,
          deferLoading: DeferLoadingStrategy.DEFER,
        },
      },
    } as CmsConfig),
  ],
})
export class MyaccountEditPreferencesModule {}
